import { DateTimeType, PlainDateType } from './dateTypes';
import { OtherString } from './otherString';
import { ReceiptType } from './receiptType';
import z from 'zod';

export type ExtractedInformationItem = z.infer<typeof ExtractedInformationItem>;
export type ExtractedInformation = z.infer<typeof ExtractedInformation>;

export const ExtractedInformationItem = z.object({
    sum: z.number().nullish(),
    tax: z.number().nullish(),
});

export const ExtractedInformation = z.object({
    id: z.string(),
    startedOn: DateTimeType,
    completedOn: DateTimeType.nullish(),
    countryCode: z.string().nullish(),
    date: PlainDateType.nullish(),
    type: ReceiptType.or(OtherString).nullish(),
    items: ExtractedInformationItem.array().nullish(),
    estimatedCost: z.number().nullish(),
});
